import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=ed4582ba&scoped=true&"
import script from "./questionList.vue?vue&type=script&lang=js&"
export * from "./questionList.vue?vue&type=script&lang=js&"
import style0 from "./questionList.vue?vue&type=style&index=0&id=ed4582ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4582ba",
  null
  
)

export default component.exports